import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SummitUtilService, UserCredentials } from '@summit/utils';

import { Observable } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

import { environment } from 'src/environments/environment';
import { WebUser } from '@summit/web-user-info';

export enum UserExistsStatus {
  EXISTS = 'EXISTS',
  NOT_EXISTS = 'NOT_EXISTS',
  UNAUTHORIZED = 'UNAUTHORIZED',
  UPDATES_MADE = 'UPDATES_MADE'
}

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private userName = 'Generic User';

  constructor(
    private http: HttpClient,
    private summitUtils: SummitUtilService
  ) { }

  public getUserName(): string {
    return this.userName;
  }

  public setUserName(userName: string): void {
    this.userName = userName;
  }

  public getCredentials(): Observable<UserCredentials | unknown> {
    return this.http.get(environment.restfulService + 'IsLoggedIn').pipe(
      mergeMap(isLoggedIn => {
        if (isLoggedIn) {
          const url = environment.restfulService + 'secured/json/credentials';
          return this.http.get<UserCredentials>(url).pipe(
            map(creds => {
              this.setUserName(creds.firstName + ' ' + creds.lastName);
              return creds;
            }),
            catchError(err => {
              const message = 'We were unable to get the user credentials right now....';
              const error = this.summitUtils.errorHandlerImpl(err, message, environment.isNotLocalhost);
              this.redirectToLogin();
              return error;
            })
          );
        } else {
          this.redirectToLogin();
        }
      }),
      catchError(err => {
        this.redirectToLogin();
        return err;
      })
    );
  }

  public checkIfUserExistsAndUpdateAccordingly(newUser: WebUser): Observable<UserExistsStatus> {
    const url = environment.restfulService + 'checkIfExistsAndUpdateAccordingly';
    return this.http.post<UserExistsStatus>(url, newUser).pipe(
      catchError(err => {
        const message = 'Something went wrong when attempting to check if user exists and update accordinly';
        return this.summitUtils.errorHandlerImpl(err, message, environment.isNotLocalhost);
      })
    );
  }

  public redirectToLogin(): void {
    // redirect the user to the login screen and create a
    // redirect cookie to have them return once they have logged in
    this.summitUtils.redirectToLogin('/auth/login');
  }
}
